import React from 'react';
import PropTypes from 'prop-types';
import { Navigate, useLocation } from 'react-router-dom';
import { useRecoilValue } from 'recoil';
import { Center, Spinner } from '@chakra-ui/react';
import { authState } from '../../state/authState';

export const ProtectedRoute = ({ children, requiredRole, requiredRoles }) => {
  const auth = useRecoilValue(authState);
  const location = useLocation();

  if (auth.isLoading) {
    return (
      <Center h="100vh">
        <Spinner size="xl" color="red.500" />
      </Center>
    );
  }

  if (!auth.isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Support both single role and array of roles
  const allowedRoles = requiredRoles || (requiredRole ? [requiredRole] : null);
  if (allowedRoles && !allowedRoles.includes(auth.user?.role)) {
    return <Navigate to="/calculator" replace />;
  }

  return children;
};

ProtectedRoute.propTypes = {
  children: PropTypes.node.isRequired,
  requiredRole: PropTypes.string,
  requiredRoles: PropTypes.arrayOf(PropTypes.string)
};

export default ProtectedRoute;
